<form
    class="flex w-96 flex-col p-5"
    [formGroup]="form">
    <h1 class="mb-5 text-center text-xl">Create client</h1>
    <mat-form-field>
        <mat-label>Title</mat-label>
        <input
            matInput
            formControlName="title" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Secure postback code</mat-label>
        <input
            matInput
            formControlName="securePostbackCode" />
    </mat-form-field>
    <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="close()">
        Submit
    </button>
</form>
